export const applicationFormUrl = '/application-form/';
export const realtorsUrl = '/realtors/';
